import React from 'react'
import {ToggleButton, ToggleButtonDefaults} from '../../inputs';

export default function Readonly(props) {
  const { onChange, checked } = props

  return (
    <ToggleButton checked={checked} onChange={onChange} label={'Readonly'} margins={ToggleButtonDefaults.margins}/>
  )
}